import { inject } from '@angular/core';

import { WaitingOnYouSignalState } from '../store';

export const waitingOnYouResolver = () => {
  const _onyouSignalState = inject(WaitingOnYouSignalState);
  const _waitingOnYouData = _onyouSignalState.$data();
  if (!_waitingOnYouData) {
    _onyouSignalState.getWaitingOnYouStates({
      requestParams: {
        filter: 'all',
        limit: 10,
        offSet: 0,
      },
    });
  }

  return !_onyouSignalState.$isLoading() && !!_onyouSignalState.$data();
};
